import React from 'react';
import { Link } from 'react-router-dom';

const BlankBoard = () => {
  return(
    <div>
    <h4>Your project is currently empty</h4>
    <br/>
    <Link to='/' className="btn">Add apps</Link>
    </div>
  );
}

export default BlankBoard;


// WEBPACK FOOTER //
// ./src/components/BlankBoard.js